export default __webpack_public_path__ + "static/media/WeatherWidgetLegendMobile.3df6abee.svg";